import { render } from "./FPluginSingleTemplate.vue?vue&type=template&id=1849e21a&scoped=true"
import script from "./FPluginSingleTemplate.vue?vue&type=script&lang=js"
export * from "./FPluginSingleTemplate.vue?vue&type=script&lang=js"

import "./FPluginSingleTemplate.vue?vue&type=style&index=0&id=1849e21a&lang=less"
import "./FPluginSingleTemplate.vue?vue&type=style&index=1&id=1849e21a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1849e21a"]])

export default __exports__